import api from './api';

export const getBudgets = async () => {
  const response = await api.get('/budgets');
  return response.data;
};

export const getBudget = async (id) => {
  const response = await api.get(`/budgets/${id}`);
  return response.data;
};

export const createBudget = async (budgetData) => {
  const response = await api.post('/budgets', budgetData);
  return response.data;
};

export const updateBudget = async (budgetId, budgetData) => {
  const response = await api.put(`/budgets/${budgetId}`, budgetData);
  return response.data;
};

export const deleteBudget = async (budgetId) => {
  const response = await api.delete(`/budgets/${budgetId}`);
  return response.data;
};

export const updateCategorySpending = async (budgetId, categoryId, amount) => {
  const response = await api.post(`/budgets/${budgetId}/category-spending`, {
    categoryId,
    amount
  });
  return response.data;
};

export const getBudgetInsights = async (id, params = {}) => {
  const response = await api.get(`/budgets/${id}/insights`, { params });
  return response.data;
};

/** GET /budgets/:id/review — includes categoryCleanupSuggestion (#224) */
export const getBudgetReview = async (id) => {
  const response = await api.get(`/budgets/${id}/review`);
  return response.data;
};

export const getBudgetCategoryAuditLogs = async (id, limit = 10) => {
  const response = await api.get(`/budgets/${id}/category-audit-logs`, { params: { limit } });
  return response.data;
};

// Safe helper for callers that only need the nested data payload
export const getBudgetInsightsSafe = async (id) => {
  try {
    const res = await api.get(`/budgets/${id}/insights`);
    if (res && res.data && res.data.data) {
      return res.data.data;
    }
    return { categorySpent: {}, period: {} };
  } catch (error) {
    return { categorySpent: {}, period: {} };
  }
};

export const getSnapshotInsights = async (range = 'all') => {
  const response = await api.get(`/budgets/insights`, { params: { range } });
  return response.data;
};

export const closeBudget = async (id, creationMode = 'auto') => {
  const response = await api.post(`/budgets/${id}/close`, { creationMode });
  return response.data;
};

export const getSuggestedBudget = async () => {
  const response = await api.get('/budgets/suggested');
  return response.data;
};

export const updateBudgetCategory = async (budgetId, categoryId, categoryData) => {
  const response = await api.put(`/budgets/${budgetId}/categories/${categoryId}`, categoryData);
  return response.data;
};

export const approveBudget = async (id) => {
  const response = await api.post(`/budgets/${id}/approve`);
  return response.data;
};
